var $3880799552ec9797$exports = {};
$3880799552ec9797$exports = {
    "valid": `Valabil`
};


export {$3880799552ec9797$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
